<template>

  <div class="main">
    <div id="card" class="card">
      <h6 class="card-header">Locations</h6>
      <div class="card-body prog-container">
        <b-table ref="table" responsive small :sort-by="'name'" :items="items" :fields="fields">

          <template slot="actions" slot-scope="row">
            <b-button variant="info" size="sm" @click="updateRow(row.item.id)" class="mr-1" style="padding-left:10px;padding-right:10px">
              Update
            </b-button>
            <b-button variant="danger" size="sm" @click="showDeleteModal(row.item.id)" class="mr-1" style="padding-left:10px;padding-right:10px">
              Delete
            </b-button>
          </template>

        </b-table>
      </div>
    </div>

    <div v-show="update" id="card" class="card">
      <h6 class="card-header">Update Location</h6>
      <div class="card-body">
        <b-container>
          <b-row align-h="start">
            <b-col cols="3">
              <b-form-input class="input" v-model="selected.name" placeholder="Name:" />
            </b-col>
            <b-col cols="6">
              <b-form-input v-model="selected.description" placeholder="Description:" />
            </b-col>
            <b-col>
              <div class="">
                <b-button variant="info" size="sm" @click="updateLocation()" class="mr-1" style="padding-left:10px;padding-right:10px">
                  Update
                </b-button>
              </div>
            </b-col>
            <b-col></b-col>
          </b-row>
        </b-container>
      </div>
    </div>

    <div id = "map">
      <div id="card" class="card">
        <h6 class="card-header">Map</h6>
        <!-- TO-DO: Adding maps to location -->
        <div class = "text-center" style="margin: 10px 0 10px 0;">
          <b-button variant="info" size="sm" @click="recenterMap()" class="mr-1">
                    Recenter Map
          </b-button>
          <b-button variant="danger" size="sm" @click="clearMarker()" class="mr-1">
                    Clear Marker
          </b-button>
        </div>
        
        <GmapMap ref="mapRef"
        :center="mapCenter"
        :zoom="mapZoom"
        map-type-id="terrain"
        style="width: 100%; height: 46vh"
        @click="mark"
        >
            <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                @click="center=m.position"
            />
            
        </GmapMap>
      </div>
    </div>

    <div id="card" class="card">
      <h6 class="card-header">Insert Location</h6>
      <div class="card-body">
        <b-container>
          <b-row align-h="start">
            <b-col cols="3">
              <b-form-input class="input" v-model="location.name"   placeholder="Name:" />
            </b-col>
            <b-col cols="5">
              <b-form-input v-model="location.description" placeholder="Description:" />
            </b-col>
            <b-col cols="2">
              <b-form-input v-model="location.latitude" placeholder="Latitude" disabled/>
            </b-col>
            <b-col cols="2">
              <b-form-input v-model="location.longitude" placeholder="Longitude" disabled/>
            </b-col>
            <b-col cols="12">
              <div class="text-center">
                <b-button variant="info" size="sm" @click="addLocation()" class="mr-1">
                  Add
                </b-button>
              </div>
            </b-col>
            <b-col></b-col>
          </b-row>
        </b-container>
      </div>
    </div>

    <div>
      <b-modal ref="my-modal" hide-footer hide-header title="Using Component Methods">
        <div class="d-block text-center">
          <p>Are you sure you want to delete this location?</p>
        </div>
        <div class="d-flex w-100 justify-content-center">
          <b-button size="sm" variant="outline-secondary" @click="toggleModal" style="margin-right:4%">Cancel</b-button>
          <b-button size="sm" variant="outline-danger" @click="deleteRow()" style>Proceed</b-button>
        </div>
      </b-modal>
    </div>

  </div>

</template>
<script>

  export default {
    created() {
      this.$overlay.show(this)
      this.$api
        .getLocations()
        .then(response => {
          if (response.status == 200) {
            this.items = response.data
          }
          this.$overlay.hide()
        })
        .catch(error => {
          this.$overlay.hide()
        })
    },
    data: () => ({
      index: 0,
      update: false,
      mapCenter: { lat:43.2557, lng:-79.8711 },
      mapZoom: 12,
      markers: [],
      location: {
        id: '',
        name: '',
        description: '',
        latitude: '',
        longitude: ''
      },
      selected: {
        id: '',
        name: '',
        description: ''
      },
      fields: [
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'description',
          label: 'Description'
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      rules: {
            required: value => !!value || 'Required.',
            
            },
      items: [],
      deleteIndex: -1

    }),


    methods: {
      toggleModal() {
        this.$refs['my-modal'].toggle('#toggle-btn')
      },
      addLocation() {
         if (this.location.name == '' || this.location.description == '' || this.location.latitude == '' || this.location.longitude == '') {
                    this.$toasted.error('Information Missing').goAway(1200)
                    return;
                }
        //TO-DO: check if adding lat/lng entries works
        if (this.location.name != '' && this.location.description != '') {
          this.$overlay.show(this)
          this.$api
            .addLocation(this.location)
            .then(response => {
              if (response.status == 200) {
                this.$toasted.success('Location added.').goAway(1200)
                this.location.id = response.data;
                this.items.push(this.location)
                this.location = {
                  id: '',
                  name: '',
                  description: '',
                  latitude: '',
                  longitude: ''
                  
                }
              }

              this.$overlay.hide()
            })
            .catch(error => {
              this.$overlay.hide()
              if (error.response.status == 404) {
                this.$toasted.error('Location already exists.').goAway(1200)
              }
            })
        }
      },
      showDeleteModal(index) {
        this.deleteIndex = index
        this.toggleModal()
      },
      deleteRow() {
        console.log(this.deleteIndex);
        this.$overlay.show(this)
        this.$api
          .deleteLocation(this.deleteIndex)
          .then(response => {
            if (response.status == 202) {
              for(let i = this.items.length -1 ; i >= 0 ; --i)
                  if(this.items[i].id == this.deleteIndex)
                      this.items.splice(i,1)
              this.$toasted.success('Location deleted.').goAway(1200)
            }
            this.$overlay.hide()
          })
          .catch(error => {
            if (error.response.status == 406)
              this.$toasted.error('Cannot delete this location as its linked with inventory items').goAway(2000)
            else this.$toasted.error(error.response.data.message).goAway(1200)
            this.$overlay.hide()
          })
        this.toggleModal()
      },
      updateRow(index) {
        this.update = true
        for(let i = 0 ; i < this.items.length ; i++)
            if(this.items[i].id == index)
                this.index = i

        console.log(index);

        //TO-DO - add lat/lng fields
        this.selected.id = this.items[this.index].id
        this.selected.name = this.items[this.index].name
        this.selected.description = this.items[this.index].description
      },
      updateLocation() {
        //TO-DO: add lat/lng check
        if (this.selected.name == '' || this.selected.description == '') {
                    this.$toasted.error('Information Missing').goAway(1200)
                    return;
                }
        this.$overlay.show(this)
        this.$api
          .updateLocation(this.selected)
          .then(response => {
            if (response.status == 202) {
              this.items[this.index].id = this.selected.id
              this.items[this.index].name = this.selected.name
              this.items[this.index].description = this.selected.description
              this.$toasted.success('Location Info updated.').goAway('1200')
            }
            this.selected = {
              id: '',
              name: '',
              description: ''
            }
            this.$overlay.hide()
            this.update = false
            this.$refs.table.refresh()
          })
          .catch(error => {
            this.$overlay.hide()
          })
      },
      mark(event){
        console.log(event.latLng.lat())
        console.log(event.latLng.lng())
        this.location.latitude = event.latLng.lat()
        this.location.longitude = event.latLng.lng()
        const markerPosition = {lat: event.latLng.lat(), lng: event.latLng.lng() }
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.panTo(markerPosition)
        })
        this.markers = [{position: markerPosition}];
      },
      recenterMap(){
        this.mapCenter = { lat:43.2557, lng:-79.8711 }
        this.mapZoom = 12
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.panTo(this.mapCenter)
        })
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.setZoom(this.mapZoom)
        })
      },
      clearMarker(){
        this.markers = []
        this.location.latitude = ''
        this.location.longitude = ''
      }
    }
  }

</script>
<style lang="css" scoped>

  .input {
    padding-left: 2%;
    padding-right: 5%;
    max-width: 300px;
  }

  .card-header {
    color: white;
    background-color: #2a2a2e;
  }

  button {
    padding-left: 8%;
    padding-right: 8%;
  }

  .main {
    width: 100%;
    height: 100%;
  }

  .prog-container {
    max-height: 300px;
    overflow-y: auto;
  }


  .card-header {
    text-align: left;
  }

</style>
